import React, { useState, useEffect } from 'react';

import { 
    GeneralTable, Dropdown, SearchBox, ConfirmationModal,
    DateRangePicker, Datepicker, FormCheckbox
} from "components";
import BillOverview from 'modules/billingPortal/billOverview/BillOverview';

import { homeColumns } from './homeColumns';

import 'assets/scss/billingPortal/modules/home.scss';
import { cloneObject, getDropdownLabel, getObjectPropertyValue, getTotalCountFromHeader, isArrayNotEmpty, isBooleanTrueNotNullUndefined, isFunction, isNotNullUndefined, isNumberValid, isObjectNotEmpty, isObjectValid, isStringEqual_caseInsensitive, isStringNotEmpty, isStringTrimEmpty, isStringTrimNotEmpty, isUserAccessDenied, isUserAccessGranted } from 'functions';
import moment from 'moment';
import { subsidiaryList } from 'constants/lists';
import useExportData from './hooks/useExportData';
import { LoadingToaster } from 'components';

export function HomePresentation(props) {
    const { 
        oneClickActionDetails,

        completeSpecificOneClickAction_status,

        generateAllUnbilledInvoices_requesting,
        generateAllUnbilledInvoices_status, 

        generateAllUnbilledAdvancePayInvoices_requesting,
        generateAllUnbilledAdvancePayInvoices_status,

        postAllUnpostedInvoicesToSqlAccount_requesting,
        postAllUnpostedInvoicesToSqlAccount_status, 

        sendAllPendingInvoices_requesting,
        sendAllPendingInvoices_status,

        getInvoiceDetailList_requesting, invoiceDetailList, invoiceDetailListHeaders,

        generateCompareUnpostedInvoices_requesting,
        compareUnpostedInvoices,
        history
    } = props;

    // States
    
    const [isBillOverviewVisible, setBillOverviewVisibility] = useState(false);
    const [selectInvoiceId, setSelectInvoiceId] = useState("");
    const [dropdownFilterValue, setDropdownFilterValue] = useState("accountCode");
    
    const [filterValue, setFilterValue] = useState("");

    const [isModalVisible_generateInvoices, setIsModalVisible_generateInvoices] = useState(false);
    const [isModalVisible_generateDebitNotes, setIsModalVisible_generateDebitNotes] = useState(false);
    const [isModalVisible_postToSQL, setIsModalVisible_postToSQL] = useState(false);
    const [isModalVisible_sendInvoices, setIsModalVisible_sendInvoices] = useState(false);
    const [isModalResetRequired, setIsModalResetRequired] = useState(false);

    const [generateInvoice_endDate, setGenerateInvoice_endDate] = useState("");
    const [generateAdvancePayInvoice_endDate, setGenerateAdvancePayInvoice_endDate] = useState("");
    const [isOnlySendingToCustomers, setIsOnlySendingToCustomers] = useState(false);

    const [shouldExportCompareUnpostedInvoices, setShouldExportCompareUnpostedInvoices] = useState(false);

    let totalUnbilledInvoices = getObjectPropertyValue(oneClickActionDetails, "TotalUnbilledInvoice");
    totalUnbilledInvoices = (isNumberValid(totalUnbilledInvoices))? totalUnbilledInvoices: 0;
    let totalUnpostedInvoice = getObjectPropertyValue(oneClickActionDetails, "TotalUnpostInvoice");
    totalUnpostedInvoice = (isNumberValid(totalUnpostedInvoice))? totalUnpostedInvoice: 0;
    let totalPendingSendInvoice = getObjectPropertyValue(oneClickActionDetails, "TotalPendingSendInvoice");
    totalPendingSendInvoice = (isNumberValid(totalPendingSendInvoice))? totalPendingSendInvoice: 0;
    
    let actionBoardDetail = [
        {
            rightButtonAction: setIsModalVisible_generateInvoices,
            urlRedirection: "dashboard/recursiveBillingSetup",
            totalIncompleteProcesses: totalUnbilledInvoices,
            typeOfIncompleteProcess: "Unbilled Billing Setup",
            rightButtonText: "Generate All",
            isDisabled: isUserAccessDenied(props, "Internal_Dashboard_View"),
            isRightButtonDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_GenerateAll"),
            isRightButtonHidden: false
        },
        // {
        //     rightButtonAction: setIsModalVisible_generateDebitNotes,
        //     urlRedirection: "dashboard/advance-pay-setup",
        //     totalIncompleteProcesses: totalUnbilledInvoices,
        //     typeOfIncompleteProcess: "Unbilled Advance Pay Setup",
        //     rightButtonText: "Generate All",
        //     isDisabled: isUserAccessDenied(props, "Internal_Dashboard_View"),
        //     isRightButtonDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_GenerateAll"),
        //     isRightButtonHidden: true
        // },
        {
            rightButtonAction: setIsModalVisible_postToSQL,
            urlRedirection: "dashboard/invoices?status=unposted",
            totalIncompleteProcesses: totalUnpostedInvoice,
            typeOfIncompleteProcess: "Unposted Invoices",
            rightButtonText: "Post All",
            isDisabled: (isUserAccessDenied(props, "Internal_Dashboard_View")),
            isRightButtonDisabled: isUserAccessDenied(props, "Internal_SqlAccount_PostAll"),
            leftButtonText: "Compare Report",
            isLeftButtonDisabled: isUserAccessDenied(props, "Internal_CompareUnpostedInvoice_View"),
            isLeftButtonHidden: false,
            isRightButtonHidden: false,
            leftButtonAction: () => {
                props.generateCompareUnpostedInvoices();
                LoadingToaster({
                  type: "info",
                  msg: "Getting compare unposted invoices...",
                });
                setShouldExportCompareUnpostedInvoices(true);
            },
        },
        {
            rightButtonAction: setIsModalVisible_sendInvoices,
            urlRedirection: "dashboard/invoices?status=pending",
            totalIncompleteProcesses: totalPendingSendInvoice,
            typeOfIncompleteProcess: "Pending Send",
            rightButtonText: "Send All",
            isDisabled: isUserAccessDenied(props, "Internal_Dashboard_View"),
            isRightButtonDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_SendAll"),
            isRightButtonHidden: false
        },
    ];
    function generateAllUnbilledInvoices() {
        if (isFunction(props.generateAllUnbilledInvoices)) {
            props.generateAllUnbilledInvoices(generateInvoice_endDate);
            setIsModalResetRequired(true);
        }
    }
    function generateAllUnbilledAdvancePayInvoices() {
        if (isFunction(props.generateAllUnbilledAdvancePayInvoices)) {
            props.generateAllUnbilledAdvancePayInvoices(generateAdvancePayInvoice_endDate);
            setIsModalResetRequired(true);
        }
    }
    function postAllUnpostedInvoicesToSqlAccount() {
        if (isFunction(props.postAllUnpostedInvoicesToSqlAccount))
            props.postAllUnpostedInvoicesToSqlAccount();
    }
    function sendAllPendingInvoices() {
        if (isFunction(props.sendAllPendingInvoices)) {
            if (isOnlySendingToCustomers) props.sendAllPendingInvoices(true);
            else props.sendAllPendingInvoices();

            setIsModalResetRequired(true);
        }
    }
    function updateResetModalState() {
        if (isStringTrimEmpty(generateInvoice_endDate) &&
            (!isOnlySendingToCustomers))
            setIsModalResetRequired(false);
    }
    function resetModalState() {
        if ((!isModalVisible_generateInvoices) || (!isModalVisible_sendInvoices)) {
            setIsModalResetRequired(true);
            setGenerateInvoice_endDate("");
            setIsOnlySendingToCustomers(false);
        }
    }
    useEffect(() => {
        updateResetModalState();
    }, [isModalResetRequired]);
    useEffect(() => {
        resetModalState();
    }, [isModalVisible_generateInvoices, isModalVisible_sendInvoices]);

    // Action Board (Data)
    function getActionBoardData(paramObj = {}) {
        if (isFunction(props.getOneClickActionDetails)) props.getOneClickActionDetails(paramObj);
    }
    useEffect(() => {
        // Get action board details
        getActionBoardData();
    }, []);
    useEffect(() => {
        // Get new data after taking action on Action Board
        if (isBooleanTrueNotNullUndefined(completeSpecificOneClickAction_status))
            getActionBoardData();
    }, [completeSpecificOneClickAction_status]);

    useEffect(() => {
        if(isStringNotEmpty(filterValue)) {
            getActionBoardData({
                subsidiary: filterValue,
            });
        }
        else {
            getActionBoardData();
        }
    }, [filterValue])

    const exportData = useExportData();
    useEffect(() => {
        if(!generateCompareUnpostedInvoices_requesting && isArrayNotEmpty(compareUnpostedInvoices) && shouldExportCompareUnpostedInvoices) {
            exportData(compareUnpostedInvoices);
            setShouldExportCompareUnpostedInvoices(false);
        }
    }, [generateCompareUnpostedInvoices_requesting]);

    // Action Board (Display)
    let actionBoards = [];
    if (isArrayNotEmpty(actionBoardDetail)) {
        actionBoards = actionBoardDetail.map((detail, idx) => {
            // Data
            let rightButtonAction = getObjectPropertyValue(detail, "rightButtonAction", "");
            let leftButtonAction = getObjectPropertyValue(detail, "leftButtonAction", "");
            let totalIncompleteProcesses = getObjectPropertyValue(detail, "totalIncompleteProcesses", "");
            let typeOfIncompleteProcessTxt = getObjectPropertyValue(detail, "typeOfIncompleteProcess", "");
            let rightButtonText = getObjectPropertyValue(detail, "rightButtonText", "");
            let isDisabled = getObjectPropertyValue(detail, "isDisabled", "");
            let isRightButtonDisabled = getObjectPropertyValue(detail, "isRightButtonDisabled", "");
            let isRightButtonHidden = getObjectPropertyValue(detail, "isRightButtonHidden", "");
            let urlRedirection = getObjectPropertyValue(detail, "urlRedirection", "");
            let leftButtonText = getObjectPropertyValue(detail, "leftButtonText", "");
            let isLeftButtonDisabled = getObjectPropertyValue(detail, "isLeftButtonDisabled", "");
            let isLeftButtonHidden = getObjectPropertyValue(detail, "isLeftButtonHidden", "");

            let isBoardEmpty = ((isNumberValid(totalIncompleteProcesses) &&
                                    totalIncompleteProcesses == 0) &&
                                    isStringTrimEmpty(typeOfIncompleteProcessTxt));

            return (
                <div key={idx} className={"home-boards-specificBoardWrapper "}>
                    <div className={"home-boards-specificBoard " + 
                            (isBoardEmpty? "":"home-boards-specificBoard_primaryBackground ") +
                            (isDisabled? "home-boards-specificBoard_disabled ":"")}
                        onClick={() => {
                            if (isNotNullUndefined(history))
                                history.push(urlRedirection);
                        }}        
                    >
                        {(!isBoardEmpty)?(
                            <>
                                <div className="d-flex justify-content-between">
                                    <div className={"home-specificBoard-action text-left " +
                                            (isDisabled || isLeftButtonDisabled? "home-specificBoard-action_disabled ":"") +
                                            (isLeftButtonHidden? "invisible ":"")}
                                        onClick={(e) => { 
                                            e.stopPropagation();
                                            if (!isDisabled && !isLeftButtonDisabled) leftButtonAction(true); 
                                        }}
                                    >
                                        {leftButtonText}
                                    </div>

                                    
                                    <div className={"home-specificBoard-action text-right " +
                                            (isDisabled || isRightButtonDisabled? "home-specificBoard-action_disabled ":"") +
                                            (isRightButtonHidden? "invisible ":"")}
                                        onClick={(e) => { 
                                            e.stopPropagation();
                                            if (!isDisabled && !isRightButtonDisabled) rightButtonAction(true); 
                                        }}
                                    >
                                        {rightButtonText}
                                    </div>
                                </div>

                                {!isDisabled? (
                                    <div className="home-specificBoard-totalIncomplete">
                                        {totalIncompleteProcesses}
                                    </div>
                                ):""}

                                <div className="home-specificBoard-incompleteType">
                                    {typeOfIncompleteProcessTxt}
                                </div>
                            </>
                        ):""}
                    </div>
                </div>
            )
        });
    }

    // Filter
    let dropdownFilterOptions = [
        {
            label: "Account Code",
            value: "accountCode"
        },
        {
            label: "Invoice ID",
            value: "invoiceId"
        },
        {
            label: "Document No",
            value: "documentNo"
        },
        {
            label: "Document Date",
            value: "documentDate"
        },
        {
            label: "Subsidiary",
            value: "subsidiary"
        }
    ];

    // Table
    function handleRowClick(rowDetails) {
        if (isObjectNotEmpty(rowDetails)) {
            let invoiceDetails = getObjectPropertyValue(rowDetails, "values");
            let invoiceID = getObjectPropertyValue(invoiceDetails, "invoiceID");

            setSelectInvoiceId(invoiceID);
            setBillOverviewVisibility(true);
        }
    }

    return (
        <div className="home">

            {/* Generate Invoices Modals */}
            <ConfirmationModal
                description={"Generating all unbilled invoices"}
                input={(
                    <Datepicker
                        label={"End Date: "}
                        handleOnChange={setGenerateInvoice_endDate}

                        isResetRequired={isModalResetRequired}
                        isConversionRequired_ISO8601
                    />
                )}

                cancelButtonText={"Cancel"}
                confirmButtonText={"Confirm"}
                isModalVisible={isModalVisible_generateInvoices}
                updateParentState={setIsModalVisible_generateInvoices}
                handleOnConfirm={generateAllUnbilledInvoices}
				isActionLoading={generateAllUnbilledInvoices_requesting}
                isConfirmSuccessful={generateAllUnbilledInvoices_status}
            />

            {/* Generate Invoices Modals */}
            <ConfirmationModal
                description={"Generating all unbilled advance pay invoices"}
                input={(
                    <Datepicker
                        label={"End Date: "}
                        handleOnChange={setGenerateAdvancePayInvoice_endDate}

                        isResetRequired={isModalResetRequired}
                        isConversionRequired_ISO8601
                    />
                )}

                cancelButtonText={"Cancel"}
                confirmButtonText={"Confirm"}
                isModalVisible={isModalVisible_generateDebitNotes}
                updateParentState={setIsModalVisible_generateDebitNotes}
                handleOnConfirm={generateAllUnbilledAdvancePayInvoices}
				isActionLoading={generateAllUnbilledAdvancePayInvoices_requesting}
                isConfirmSuccessful={generateAllUnbilledAdvancePayInvoices_status}
            />

            {/* Post to SQL Modal */}
            <ConfirmationModal
                description={"Posting all unposted invoices to Netsuite account"}
                cancelButtonText={"Cancel"}
                confirmButtonText={"Confirm"}
                isModalVisible={isModalVisible_postToSQL}
                updateParentState={setIsModalVisible_postToSQL}
                handleOnConfirm={postAllUnpostedInvoicesToSqlAccount}
				isActionLoading={postAllUnpostedInvoicesToSqlAccount_requesting}
                isConfirmSuccessful={postAllUnpostedInvoicesToSqlAccount_status}
            />

            {/* Send Invoices Modal */}
            <ConfirmationModal
                description={"Sending emails for all pending invoices"}
                input={(
                    <FormCheckbox
                        checkboxLabel={"Send to customers only"}
                        handleCheckboxSelectionSub={(checkboxID, isChecked) => { setIsOnlySendingToCustomers(isChecked); }}
                        isDecoration_lightBackground
                        isResetRequired={isModalResetRequired}

                        checkboxClassName={"generalTable-bodyCheckboxWrapper-box "}

                        checkboxIconClassName={"generalTable-bodyCheckboxWrapper-icon "}

                        checkboxID={"table_checkboxID_"}
                    />
                )}

                cancelButtonText={"Cancel"}
                confirmButtonText={"Confirm"}
                isModalVisible={isModalVisible_sendInvoices}
                updateParentState={setIsModalVisible_sendInvoices}
                handleOnConfirm={sendAllPendingInvoices}
				isActionLoading={sendAllPendingInvoices_requesting}
                isConfirmSuccessful={sendAllPendingInvoices_status}
            />


            {(isBillOverviewVisible)? (
                <BillOverview 
                    invoiceNo={selectInvoiceId} 
                    updateParentState_visiblity={setBillOverviewVisibility}
                />
            ):(
                <>
                    <div className="home-header">
                        {/* Title */}
                        <div className="home-headerTitle pageHeaderTitle ">
                            Home
                        </div>

                        {/* Action Boards */}
                        <div className="home-headerActionBoard">
                            {/* Title */}
                            <div className={"home-actionBoardTitle"}>
                                One-Click Action Boards
                            </div>

                            {/* List of Boards */}
                            <div className="home-actionBoardBoards d-flex">
                                {actionBoards}
                            </div>
                        </div>

                    </div>

                    <div className="home-body">
                        <GeneralTable
                            columns={homeColumns.getColumns()}
                            data={invoiceDetailList}
                            getTableData={isUserAccessGranted(props, "Internal_ProformaInvoice_View")? props.getTableDetails:()=>{}}

                            defaultFilter={{
                                filterFrom: moment().startOf('month').format("YYYY/MM/DD"),
                                filterTo: moment().endOf('month').format("YYYY/MM/DD"),
                            }}

                            outerTableHeader={(outerTableHeader_props) => {
                                const { 
                                    selectedRows: selectedAccounts,
                                    filterOptions, setFilterOptions
                                } = outerTableHeader_props;


                                let input = (
                                    <SearchBox
                                        className={"home-table-searchBox"}
                                        placeholder={"Search by " + getDropdownLabel(dropdownFilterOptions, dropdownFilterValue)}
                                        handleOnEnterPressed={(value) => { 
                                            setFilterValue(value);
                                            
                                            let filterOptions_new = cloneObject(filterOptions);
                                            if (isObjectValid(filterOptions)) {
                                                filterOptions_new[dropdownFilterValue] = value;
                                            }
                                            setFilterOptions(filterOptions_new);
                                        }}
                                        onSubmit={(value) => { 
                                            setFilterValue(value);
                                            
                                            let filterOptions_new = cloneObject(filterOptions);
                                            if (isObjectValid(filterOptions)) {
                                                filterOptions_new[dropdownFilterValue] = value;
                                            }
                                            setFilterOptions(filterOptions_new);
                                        }}
                                        handleOnEmptyInput={() => { 
                                            setFilterValue("");
                                            setFilterOptions({}); 
                                        }}
                                    />
                                );

                                if (isStringEqual_caseInsensitive(dropdownFilterValue, "documentDate")) {
                                    input = (
                                        <DateRangePicker
                                            inputWrapperClassName={"home-tableFilter-datepicker"}

                                            handleOnChange_start={(value) => { 
                                                setFilterValue(value);

                                                let filterOptions_new = cloneObject(filterOptions);
                                                if (isObjectValid(filterOptions)) {
                                                    filterOptions_new["filterFrom"] = value;
                                                }
                                                setFilterOptions(filterOptions_new);
                                            }}
                                            handleOnEmptyInput_start={() => { 
                                                setFilterValue("");
                                                setFilterOptions({}); 
                                            }}

                                            handleOnChange_end={(value) => { 
                                                setFilterValue(value);

                                                let filterOptions_new = cloneObject(filterOptions);
                                                if (isObjectValid(filterOptions)) {
                                                    filterOptions_new["filterTo"] = value;
                                                }
                                                setFilterOptions(filterOptions_new);
                                            }}
                                            handleOnEmptyInput_end={() => { 
                                                setFilterValue("");
                                                setFilterOptions({}); 
                                            }}

                                            isConversionRequired_ISO8601
                                        />
                                    );
                                }

                                if (isStringEqual_caseInsensitive(dropdownFilterValue, "subsidiary")) {
                                    input = (
                                        <Dropdown
                                            className={"home-table-dropdown"}
                                            placeholder={"Select..."}
                                            options={[{ label: "All", value: "" }].concat(subsidiaryList)}
                                            onChange={(value) => {
                                                setFilterValue(value);
                                            
                                                let filterOptions_new = cloneObject(filterOptions);
                                                if (isObjectValid(filterOptions)) {
                                                    filterOptions_new[dropdownFilterValue] = value;
                                                }
                                                setFilterOptions(filterOptions_new);
                                            }}
                                            onEnterKeyPressed={(value) => {
                                                setFilterValue(value);
                                            
                                                let filterOptions_new = cloneObject(filterOptions);
                                                if (isObjectValid(filterOptions)) {
                                                    filterOptions_new[dropdownFilterValue] = value;
                                                }
                                                setFilterOptions(filterOptions_new);
                                            }} 
                                            isSearchable
                                        />
                                    );
                                }

                                return (
                                    <div className={"outer-table-header d-flex justify-content-between align-items-center"}>
                                        <div className={"outer-table-header__title tableHeaderTitle "}>
                                            Invoices
                                        </div>

                                        <div className={"outer-table-header__filters d-flex align-items-center"}>
                                            {/* Dropdown Search Filter */}
                                            <Dropdown
                                                selectedValueWrapperClassName={"home-table-filter"}
                                                options={dropdownFilterOptions}
                                                selectedValue_default={dropdownFilterValue}
                                                onChange={(value) => { 
                                                    if (isStringTrimNotEmpty(filterValue)) setFilterOptions({}); 
                                                    setDropdownFilterValue(value);
                                                }}
                                            />

                                            {/* Search Input */}
                                            {input}
                                        </div>
                                    </div>
                                );
                            }}

                            onRowClick={handleRowClick}

                            isUsingPagination
                            pageSize={10}
                            totalRecords={getTotalCountFromHeader(invoiceDetailListHeaders)}

                            isTableDataLoading={getInvoiceDetailList_requesting}
                            isColumnResizeable isAllColumnWidthEqual
                            isTableOddRowsDarken
                        />
                    </div>
                </>
            )}
        </div>
    );
}
